<section
  class="halftone-tide"
  aria-hidden="true"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-speed-input]="speed"
  [style.--scene-intensity-input]="intensity"
  [style.--dot-step]="dotStep"
>
  <div class="tide-glow"></div>
  <div class="tide tide-a"></div>
  <div class="tide tide-b"></div>
</section>
